import { useInstance } from '@meraki-internal/react-dependency-injection';
import { AppPrincipal, isCaremapViewer } from '../auth/AppPrincipal';
import { AlertPresenter } from '../AlertBinder';
import { HistoryViewModel } from '../support/HistoryViewModel';
import { Auth0AuthService } from '../auth/AuthService';

export class LoginNudgeAlert {
    static inject = () => [
        AlertPresenter,
        Auth0AuthService,
        HistoryViewModel
    ];

    constructor(
        private alert: AlertPresenter,
        private auth: Auth0AuthService,
        private history: HistoryViewModel
    ) {};

    show = async ({
        message,
        redirect
    }: {
        message?: string;
        redirect?: string;
    }) => {
        const action = await this.alert.showAlertV2({
            header: 'Login Required',
            message: message || 'You must be logged in to use this functionality.',
            options: [{
                id: 'cancel',
                role: 'cancel',
                label: 'Not Now'
            }, {
                id: 'continue',
                label: 'Continue'
            }]
        });

        if (action === 'continue'){
            await this.auth.login({ returnTo: redirect });
        }
    };
};

export const useIfLoggedIn = () => {
    // anonymous viewer
    const isViewer = isCaremapViewer(useInstance(AppPrincipal));
    const loginNudge = useInstance(LoginNudgeAlert);

    return async ({
        delegate,
        unathenticatedDelegate,
        message,
        redirect
    }: {
        delegate: () => void;
        unathenticatedDelegate?: () => void;
        message?: string;
        redirect?: string;
    }) => {
        if (isViewer) {
            if (unathenticatedDelegate) {
                unathenticatedDelegate();
            }
            await loginNudge.show({ message, redirect });
        } else {
            delegate();
        }
    };
};
